export const STRINGS = {
  TITLE: 'Oops, you have multiple tabs of the simulation open!',
  INFO:
    'Please reload this page or close it and continue playing on the other tab.',
  RELOAD_BUTTON: 'Reload',
  CLOSE_BUTTON: 'Close tab',
} as const;
